// GraphQL Types - Generated from schema
export interface Address {
  id: number
  name: string
  address: string
  countryId: number
  regionId: number
  locationId: number
  lattitude: string
  longitude: string
  created: string
  modified: string
  deleted: number
  Country?: Country
  Region?: Region
  Location?: Location
}

export interface Country {
  id: number
  name: string
  iso: string
  active: number
  sortOrder: number
  created: string
  modified: string
  deleted: number
}

export interface Region {
  id: number
  name: string
  alias: string
  fullName?: string
  countryId: number
  sortOrder: number
  created: string
  modified: string
  deleted: number
}

export interface Location {
  id: number
  name: string
  countryId: number
  regionId: number
  sortOrder: number
  created: string
  modified: string
  deleted: number
}

export interface Format {
  id: number
  name: string
  description: string
  image: string
  sortOrder: number
  status: number
  deckbuilder: number
  maxCopies: number
  minDeck: number
  maxDeck: number
  sideboard: number
  extraCards: number
  isFullRacial: number
  created: string
  updated: string
  deleted: number
  urlUpdate?: string
  totalTournaments?: string
  Tournaments?: Tournament[]
  FormatGames?: FormatGame[]
}

export interface TournamentType {
  id: number
  name: string
  urlImage?: string
  urlImage2?: string
  urlImage3?: string
  urlImage4?: string
  minPlayers?: number
}
export interface Tournament {
  id: number
  parentId: number
  name: string
  uid: string
  description?: string
  image?: string
  eventUrl?: string
  urlView?: string
  urlAddPlayers?: string
  urlRounds?: string
  urlImage?: string

  storeId?: number
  gameId?: number
  addressId?: number
  seasonId?: number
  role?: "JUEZ" | "JUGADOR"
  statusId?: number
  typeId?: number
  formatId?: number
  isPresential?: boolean
  maxPlayers?: number
  rounds?: number
  rankingValid?: number
  startDate: string
  isPrivate: boolean
  endDate?: string
  processedDate?: string
  validDates?: boolean
  Store?: Store
  Game?: Game
  Address?: Address
  Season?: Season
  Format?: Format
  TournamentType?: TournamentType
}

export interface Store {
  id: number
  name: string
  description?: string
  phone?: string
  email?: string
  website?: string
  logo?: string
  /**
   * - 1 Organizador
   * - 2 Tienda Oficial
   * - 3 Tienda Oficial Klu
   */
  levelId?: number
  banner?: string
  addressId?: number
  ownerId?: number
  active: number
  verified: number
  created: string
  modified: string
  deleted: number
  Address?: Address
  Tournaments?: Tournament[]
}

export interface Game {
  id: number
  name: string
  description?: string
  sortOrder?: number
  image?: string
  website?: string
  rules?: string
  status: number
  isActive: number
  urlImage?: string
  urlIcon?: string
  urlUpdate?: string
  totalTournaments?: number
  urlActiveSeason?: string
  Formats?: Format[]
  Tournaments?: Tournament[]
  Seasons?: SeasonBasic[]
}

export interface SeasonBasic {
  id: number
  name: string
  description: string
  isActive: number
  isArchived: number
  startDate: Date
  endDate: Date
  rankingUrl?: string
  gameId: number
}

export interface Season {
  id: number
  name: string
  description?: string
  startDate?: string
  endDate?: string
  gameId?: number
  rankingUrl?: string
  status: number
  isActive: number
  isArchived: number
  totalTournaments?: number
  created: string
  modified: string
  deleted: number
  Game?: Game
  Tournaments?: Tournament[]
}

export interface Player {
  id: number
  name: string
  email?: string
  phone?: string
  nickname?: string
  avatar?: string
  active: number
  verified: number
  created: string
  modified: string
  deleted: number
}

export interface User {
  id: number
  username?: string
  email?: string
  password?: string
  firstName?: string
  lastName?: string
  avatar?: string
  active: number
  verified: number
  created: string
  modified: string
  deleted: number
}

export interface Gender {
  name: string
}

export interface PersonProfile {
  profileId: number
}

export interface Level {
  name: string
}

export interface StoreTournamentType {
  typeId: number
  quantity: number
}

export interface Person {
  id: number
  name: string
  firstSurname: string
  lastSurname: string
  fullName: string
  nickname?: string
  email: string
  phone?: string
  emailValid: number
  birthday?: string
  active: number
  code: string
  categoryId: number
  codeOld?: string
  genderId: number
  created: string
  avatar?: string
  urlAvatar?: string
  PersonProfiles?: PersonProfile[]
  Gender?: Gender
  Store?: StoreDetail
  Address?: Address
}

export interface StoreDetail {
  id: number
  name: string
  description?: string
  logo?: string
  urlLogo?: string
  cover?: string
  urlCover?: string
  phone?: string
  email?: string
  active: number
  siteUrl?: string
  facebookUrl?: string
  instagramUrl?: string
  twitterUrl?: string
  youtubeUrl?: string
  urlView?: string
  urlTournaments?: string
  urlPastTournaments?: string
  Person?: Person
  Address?: Address
  Level?: Level
  StoreTournamentTypes?: StoreTournamentType[]
}

export interface UserInfo {
  User: {
    id: number
    Person: Person
  }
}

export interface FormatGame {
  id: number
  formatId: number
  gameId: number
  deleted: number
  Game?: Game
  Format?: Format
}

// Filter types
export interface TournamentFilter {
  id?: number
  name?: string
  name_contains?: string
  storeId?: number
  gameId?: number
  seasonId?: number
  statusId?: number
  formatId?: number
  startDate?: string
  endDate?: string
  rankingValid?: number
}

export interface StoreFilter {
  id?: number
  name?: string
  name_contains?: string
  active?: number
  verified?: number
  addressId?: number
}

export interface GameFilter {
  id?: number
  name?: string
  name_contains?: string
  status?: number
  isActive?: number
}

export interface SeasonFilter {
  id?: number
  name?: string
  name_contains?: string
  gameId?: number
  status?: number
  isActive?: number
  isArchived?: number
}

export interface PlayerFilter {
  id?: number
  name?: string
  name_contains?: string
  email?: string
  nickname?: string
  active?: number
  verified?: number
}

// Order by enums
export enum TournamentOrderBy {
  ID_ASC = "id_ASC",
  ID_DESC = "id_DESC",
  NAME_ASC = "name_ASC",
  NAME_DESC = "name_DESC",
  START_DATE_ASC = "startDate_ASC",
  START_DATE_DESC = "startDate_DESC",
  END_DATE_ASC = "endDate_ASC",
  END_DATE_DESC = "endDate_DESC",
}

export enum StoreOrderBy {
  ID_ASC = "id_ASC",
  ID_DESC = "id_DESC",
  NAME_ASC = "name_ASC",
  NAME_DESC = "name_DESC",
  CREATED_ASC = "created_ASC",
  CREATED_DESC = "created_DESC",
}

export enum SeasonOrderBy {
  ID_ASC = "id_ASC",
  ID_DESC = "id_DESC",
  NAME_ASC = "name_ASC",
  NAME_DESC = "name_DESC",
  START_DATE_ASC = "startDate_ASC",
  START_DATE_DESC = "startDate_DESC",
}

// Request and Response types
export interface RequestStatusTypeObject {
  code: number
  message: string
  success: boolean
}

export interface FieldValidationError {
  field: string
  errors: string[]
}

// Pagination
export interface PaginationInput {
  page?: number
  paginate?: number
}

// Auth types
export interface UserLoginInput {
  username: string
  passwd: string
  type: string
}

export interface LoginStatus {
  code: number
  name: string
  success: boolean
  detail: string
}

export interface LoginPayload {
  token: string
  status: LoginStatus
}

export interface UserRegisterInput {
  name: string
  firstSurname: string
  lastSurname: string
  email: string
  birthday: string
  passwd: string
  phone: string
  genderId: number
  categoryId: number
  documentType?: string
  documentNumber?: string
  address: {
    name: string
    address: string
    countryId: number
    regionId: number
    locationId: number
  }
}

export interface Person {
  id: number
  fullName: string
  code: string
  nickname?: string
  email: string
  avatar?: string
  urlAvatar?: string
}

export interface AddressConfirmInput {
  countryId: number
  regionId: number
  locationId?: number
}

export interface AddressConfirmPayload {
  status: {
    success: boolean
    name: string
    detail?: string
  }
  address?: Address
}

export interface RegisterPayload {
  status: {
    success: boolean
    name: string
    detail: string
  }
  person: Person
}

export interface UserPasswdRecoverInput {
  search: string
}

export interface AuthPayload {
  token?: string
  user?: User
  status: RequestStatusTypeObject
}
